export default function generateImageResizer(
  imageUrl: string,
  size: number,
  extension: string = 'webp'
) {
  if (imageUrl?.startsWith(process.env.NEXT_PUBLIC_IMAGE_BASE_URL)) {
    return (
      imageUrl.replace(
        process.env.NEXT_PUBLIC_IMAGE_BASE_URL,
        process.env.NEXT_PUBLIC_RESIZER_BASE_URL
      ) + `?s=${size}&f=${extension}`
    );
  }

  return imageUrl;
}
